/* eslint-disable @typescript-eslint/no-explicit-any */
// import './validation.d';
import * as yup from 'yup';

yup.addMethod(
  yup.string,
  'nullToDefault',
  function nullToDefault(defaultValue) {
    return this.transform((value) => {
      if (value === null) {
        return defaultValue;
      }
      return value;
    });
  }
);

export const yep = yup;

export const validateTypename = (typename: string) =>
  yep.object().shape({
    __typename: yep.string().oneOf([typename]).required(),
  });

// TODO: More tightly enforce the index signature for the object shape... see below for a half-hearted attempt
export const validatePaginatedEdgesResponse = <
  O extends yup.ObjectSchema<any, any, any, any> = yup.ObjectSchema<
    any,
    any,
    any,
    any
  >
>(
  typename: string,
  of: O,
  edgesTypename = `${typename}Edges`,
  edgeTypename = `${typename}Edge`
) =>
  yep
    .object()
    .shape({
      edges: yep
        .array()
        .of(
          yep
            .object()
            .shape({
              cursor: yep.number().required(),
              node: of,
            })
            .concat(validateTypename(edgeTypename))
        )
        .nonNullable()
        .required(),
    })
    .concat(validateTypename(edgesTypename))
    .nonNullable()
    .required();

// export const validatePaginatedEdgesResponse = <
//   K extends string,
//   O extends yup.ObjectShape
// >(
//   name: K,
//   of: O
// ) => {
//   type ValidatedResponse = {
//     [key in K]: yup.ObjectSchema<any, any, any, any>;
//   };

//   return yup
//     .object<ValidatedResponse>()
//     .shape({
//       [name]: yup
//         .object()
//         .shape({
//           edges: yep.array().of(yep.object().shape(of)).required(),
//         })
//         .required(),
//     })
//     .required();
// };
